import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import {
	getFavArtisanProductsAction,
	removeFavArtisanPoductAction,
} from "../../../modules/customerFavArtisanProducts/Actions";
import {
	customerFavArtisanProducsCountSelector,
	customerFavArtisanProducsLoadingSelector,
	customerFavArtisanProductsAsNameAndId,
	searchValueSelector,
} from "../../../modules/customerFavArtisanProducts/Selectors";
import List from "../../../components/Lists/List";
import ListItem from "../../../components/Lists/ListItem";
import InfiniteScroll from "react-infinite-scroll-component";
import { customerDataSelector } from "../../../modules/auth/Selectors";
import getLangData from "../../../utils/getLangData";

const CustomerFavArtisanProductList = (props) => {
	const {
		favArtisanProducts,
		getFavArtisanProducts,
		favArtisanProductsIsLoading,
		favArtisanProductsCount,
		removeFavArtisanProduct,
		customerData,
		// artisans,
		// artisansIsLoading,
		// getArtisans,
		// deleteArtisan,
		// artisansCount,
	} = props;

	const [size, setSize] = useState(10);
	const [offset, setOffset] = useState(0);
	const [hasMore, setHasMore] = useState(true);

	// for testing the id remember to remove and use dynamic id
	const customerId = customerData?._id;
	useEffect(() => {
		console.log(customerId,customerData, 'customerId')
		getFavArtisanProducts({ customerId });
	}, [getFavArtisanProducts]);

	const fetchMore = () => {
		// set hasMore to false if the current items are >= the all items in database !
		// if (favArtisanProducts.length >= favArtisanProductsCount) {
		//   setHasMore(false);
		//   return false;
		// }
		// // otherwise get the data from the database
		// getArtisans({ size, offset: favArtisanProducts.length });
	};

	const dataLength =
		favArtisanProducts.length <= favArtisanProductsCount
			? favArtisanProducts.length
			: favArtisanProductsCount;

	return (
		<InfiniteScroll
			dataLength={dataLength}
			hasMore={hasMore}
			next={fetchMore}
			style={{ overflow: "hidden" }}
		>
			<div className="table row block--container my-5">
				<List
					isLoading={favArtisanProductsIsLoading}
					header={{ items: [getLangData().fields.name], actions: ["View", "Delete"] }}
					items={favArtisanProducts}
				>
					<table className="table">
						<tbody>
							{favArtisanProducts.map(({ _id, name }) => {
								return (
									<ListItem
										name={name}
										key={_id}
										viewLink={`/artisan-fav-products/${_id}`}
										onDelete={() => {
											const data = { customerId, productID: _id };
											const productID = _id;
											removeFavArtisanProduct(customerId, productID);
										}}
									/>
								);
							})}
						</tbody>
					</table>
				</List>
			</div>
		</InfiniteScroll>
	);
};

const mapStateToProps = (state) => ({
	favArtisanProducts: customerFavArtisanProductsAsNameAndId(state),
	favArtisanProductsIsLoading: customerFavArtisanProducsLoadingSelector(state),
	favArtisanProductsCount: customerFavArtisanProducsCountSelector(state),
	customerData: customerDataSelector(state)
	// artisans: pendingArtisanProductsAsListSelector(state),
	// artisansIsLoading: pendingArtisanProductsIsLoadingSelector(state),
	// artisansCount: pendingArtisanProductsCountSelector(state),
});

export default connect(mapStateToProps, {
	// getArtisans: getPendingArtisanProductsAction,
	// deleteArtisan:deleteSinglePendingArtisanProdcutAction,
	getFavArtisanProducts: getFavArtisanProductsAction,
	removeFavArtisanProduct: removeFavArtisanPoductAction,
})(CustomerFavArtisanProductList);
